import { Loader2 } from "lucide-react";

/**
 * Full-page loading spinner shown during lazy chunk loads.
 * Uses min-height to prevent layout shift.
 */
export default function PageSpinner() {
  return (
    <div
      className="flex min-h-screen items-center justify-center"
      role="status"
      aria-label="Загрузка страницы"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
